"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const functions_1 = require("@/common/functions");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ pendingRef, handleSubmit, reviewId, }) {
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const queryClient = (0, react_query_1.useQueryClient)();
    const onReviewReplySuccess = (reviewReplyData) => {
        queryClient.setQueriesData(['reviewContentsData'], data => data && Object.assign(Object.assign({}, data), { pages: data.pages.map(page => (Object.assign(Object.assign({}, page), { result: page.result.map(review => review.id === reviewId ? Object.assign(Object.assign({}, review), reviewReplyData) : review) }))) }));
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const onSubmitReviewReply = handleSubmit((inputData) => __awaiter(this, void 0, void 0, function* () {
        if (!pendingRef.current) {
            const { reply_photo_thumb, reply_photo } = inputData;
            if (!reply_photo_thumb) {
                (0, functions_1.showToastMessage)({ message: t('사진을 등록해 주세요') });
            }
            else {
                pendingRef.current = true;
                setIsPending(true);
                const reviewReplyData = {
                    review_reply_photo_01: reply_photo,
                    review_reply_photo_thumb_01: reply_photo_thumb,
                };
                yield (0, api_1.postData)(`/api/v1/order/review/reply/${reviewId}`, reviewReplyData)
                    .then(res => {
                    (0, functions_1.showToastMessage)({ message: t('등록 완료') });
                    onReviewReplySuccess(Object.assign(Object.assign({}, reviewReplyData), { reply_reg_date: res.data.reply_reg_date }));
                })
                    .catch(err => {
                    var _a, _b, _c, _d;
                    pendingRef.current = false;
                    setIsPending(false);
                    const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
                    const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                    (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                });
            }
        }
    }));
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: onSubmitReviewReply, sx: {
            width: '100%',
            height: '40px',
            padding: '0 16px',
            borderRadius: '8px',
            bgcolor: 'var(--primary-main) !important',
            color: 'var(--white)',
        } }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 20, color: "inherit", thickness: 4 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4" }, { children: t('등록') }))) })));
}
exports.default = default_1;
